// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"3a282348","488":"508dbb11"}[chunkId] + ".chunk.js";
};